import { Tooltip, TooltipContent, TooltipTrigger } from '~/primitives/tooltip';
import { useSettingsStore } from '~/util/stores/settings';

const PointValueDisplay = ({
    value,
    compact,
}: {
    value: number;
    compact: boolean;
}) => {
    const roundedValue = value ? Math.floor(value) : undefined;
    const displayedValue = roundedValue
        ? compact && roundedValue >= 100_000
            ? `${Math.floor(roundedValue / 1_000)}k`
            : compact && roundedValue >= 10_000
              ? `${(Math.floor(roundedValue / 100) / 10).toFixed(1)}k`
              : compact && roundedValue >= 1_000
                ? `${(Math.floor(roundedValue / 10) / 100).toFixed(2)}k`
                : `${roundedValue}`
        : undefined;

    return displayedValue ? (
        <Tooltip delayDuration={0}>
            <TooltipContent side="bottom">
                <p>{`${value}`}</p>
            </TooltipContent>
            <TooltipTrigger>{displayedValue}</TooltipTrigger>
        </Tooltip>
    ) : (
        '-'
    );
};
export const UserPointDisplay = ({
    label,
    value,
}: {
    label: string;
    value: number;
}) => {
    const { points_compact_enabled } = useSettingsStore();
    return (
        <div className="text-center text-secondary-foreground">
            <p className="clamp-[text-xl-4xl-clamp] lg:clamp-[text-lg-xl-clamp] leading-[1!important] uppercase">
                {label}
            </p>
            <span className="clamp-[text-4xl-6xl-clamp] lg:clamp-[text-xl-4xl-clamp] leading-[1.25!important] font-semibold text-secondary-foreground">
                <PointValueDisplay
                    value={value}
                    compact={points_compact_enabled}
                />
            </span>
        </div>
    );
};

export const CountryClanPointDisplay = ({
    label,
    value,
}: {
    label: string;
    value: number;
}) => (
    <div className="text-center text-secondary-foreground">
        <p className="clamp-[text-xl-4xl-clamp] lg:clamp-[text-lg-xl-clamp] leading-[1!important] uppercase">
            {label}
        </p>
        <span className="clamp-[text-5xl-8xl-clamp] lg:clamp-[text-2xl-4xl-clamp] leading-[1.25!important] font-semibold text-secondary-foreground">
            {value ? Math.floor(value) : '-'}
        </span>
    </div>
);

export const RankDisplay = ({
    label,
    value,
}: {
    label: string;
    value: number | undefined;
}) => {
    return (
        <div className="flex justify-between border-b py-2">
            <span className="text-secondary-foreground">{label}</span>
            <span>{value ? `#${value}` : '-'}</span>
        </div>
    );
};
